
import { Route } from 'react-router-dom';

import NtIdManagementPage from '../../features/AdminDashboard/AccessAdministration/pages/NtIdManagementPage';
import ReportPermissionRoute from '../ReportPermissionRoute';

const AdminRoutes = () => {
  return (
    <>
      <Route
        path="/nt-id-management"
        element={
          <ReportPermissionRoute
            requiredPermission="NTIdManagement"
            deniedTo="/404"
          >
            <NtIdManagementPage />
          </ReportPermissionRoute>
        }
      />
    </>
  );
};

export default AdminRoutes;
